import React from "react";

import ProfileContainer from "../../rows/ProfileContainer";
import EditProfile from "../../molecules/EditProfile";

const EditProfilePage = () => (
  <ProfileContainer type="profile" hideTopAd={true}>
    <EditProfile />
  </ProfileContainer>
);

export { EditProfilePage };
